import { Tag } from "antd"
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export const LinkedToRiskTag = () => {
  const intl = useIntl();

  return (
    <Tag color="purple" bordered={false} icon={<FontAwesomeIcon size="sm" icon={faTriangleExclamation as IconProp} />}>
      {intl.formatMessage({ id: "risksAndIssues.linkedToRisk" })}
    </Tag>
  );
};
